import { getApiKey } from "../../utils/apiKey";
import React, { useEffect, useState } from "react";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";
import { apiCall_domain } from "../api";
import axios from "axios";

export default function DetailsUserCar({ carId }) {
  const [state, setState] = useState({
    fields: [],
    average_monthly_consumption: "",
    current_mileage: "",
    loading: false,
  });
  const fetchData = () => {
    setState({ ...state, loading: true });
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/reminder/car/fields/${carId}`, {
        headers,
      })
      .then((res) => {
        setState({
          loading: false,
          fields: res.data.data.fields.filter((field) =>
            [1, 2, 6, 7, 8].includes(field.id),
          ),
          average_monthly_consumption:
            res.data.data.car.average_monthly_consumption,
          current_mileage: res.data.data.car.current_mileage,
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, [carId]);

  const hasExpired = {
    0: "green",
    1: "red",
    2: "white",
  };
  return (
    <>
      {state.loading ? (
        <Spinner />
      ) : (
        <>
          <div className="DetailsUserCarReminderCop">
            <div className="CurrentCarMileage">
              <div className="currentMilaege">
                <span className="text">کیلومتر فعلی خودرو</span>
                <span className="value">
                  {state.current_mileage == undefined
                    ? "مقدار دهی نشده است "
                    : state.current_mileage}
                </span>
              </div>
              <div className="currentMilaege">
                <span className="text">میزان مصرف ماهانه</span>
                <span className="value">
                  {state.average_monthly_consumption == undefined
                    ? "مقدار دهی نشده است"
                    : state.average_monthly_consumption}
                </span>
              </div>
            </div>
            <div className="lastReplacement">
              <div className="OilService"></div>
            </div>
            <div className="fieldsReminder">
              <div className="reminderCarInfo">
                <h4>اطلاعات خودرو شما</h4>
                <div>
                  {state.fields.map((field) => (
                    <div className={`${hasExpired[field.has_expired]}`}>
                      <i
                        className={`reminder-field icon-reminder-${field.id} ${
                          hasExpired[field.has_expired]
                        }`}
                      />
                    </div>
                  ))}
                  {/* <div>
            <img src="/public/assets/icons/breaks.png" alt="icon" />
          </div>
          <div>
            <img src="/public/assets/icons/tire.svg" alt="icon" />
          </div>
          <div>
            <img src="/public/assets/icons/oil.png" alt="icon" />
          </div>
          <div>
            <img src="/public/assets/icons/Engine.png" alt="icon" />
          </div> */}
                </div>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center gap-4 w-100 position-absolute px-4 "
            style={{ bottom: "1rem" }}
          >
            <button className="addReminderBtn">
              <Link to={"/addReminder"}>افزودن یادآوری و بروز رسانی</Link>
            </button>
            <button className="addReminderBtn">
              <Link to={"/evaluation"}>ارزیابی</Link>
            </button>
          </div>
        </>
      )}
    </>
  );
}
